<script setup lang="ts">
import { useWakeLock } from '@vueuse/core'
import { usePage } from '@inertiajs/vue3'
import Echo from 'laravel-echo'

const authProps = computed(() => usePage().props.auth)

const useAuth = useAuthStore()

onBeforeMount(() => {
  window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT,
    wssPort: import.meta.env.VITE_REVERB_PORT,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
  })
})

onMounted(async () => {
  useAuth.init()

  const { user, company } = authProps.value

  useAuth.makeSession({
    user,
    company,
  })

  try {
    const { isSupported, request } = useWakeLock()

    if (isSupported) {
      request('screen')
    }
  } catch {}
})
</script>
<template>
  <slot />
</template>
